import dotenv from 'dotenv'

dotenv.config()

const CLIENT_ID = process.env.REACT_APP_SLACK_CLIENT_ID
export const AUTH_URL =
  'https://slack.com/oauth/v2/authorize?scope=channels:read,chat:write,commands,groups:read,im:read,links:write,users.profile:read,chat:write.public&client_id=' +
  CLIENT_ID
